import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'warning']

  connect() {
    this.toggleWarning()
  }

  inputChanged() {
    this.toggleWarning()
  }

  toggleWarning() {
    const hasValue = this.inputTarget.value && this.inputTarget.value.trim() !== ''

    if (hasValue) {
      this.warningTarget.classList.remove('hidden')
    } else {
      this.warningTarget.classList.add('hidden')
    }
  }
}
